import React, { Component } from "react";
import Slider from "react-slick";
import ReactSVG from 'react-svg';
import "../responsive/sliderBlog.css"

//import image_A4 from "../../assets/blog_images/image_A4.png";
import image_A5 from "../../assets/blog_images/image_A5.png";
import image_A6 from "../../assets/blog_images/image_A6.png";
import image_A7 from "../../assets/blog_images/image_A7.png";
import image_A8 from "../../assets/blog_images/image_A8.png";
//import image_A9 from "../../assets/blog_images/image_A9.png";
import arrow from "../../assets/blog_images/arrow.svg";

export default class SliderBlog extends Component {
    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 2,
            arrows: false,
            responsive: [
                {
                  breakpoint: 750,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true
                  }
                }
              ]
        };
        return (
            <div style={{paddingBottom: "5%"}}>
                <Slider {...settings}>
                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A5} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid">Why do you need internet of things IoT?</p>
                            <p className="dateArticleSlid">01 october,2018</p>
                        </div>
                    </div>


                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A5} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid">Artificial Intelligence: What about Chifco?</p>
                            <p className="dateArticleSlid">26 Septembre, 2018</p>
                        </div>
                    </div>


                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A6} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid">4 advices to build a successful IoT Startup</p>
                            <p className="dateArticleSlid">2 Mai, 2018</p>
                        </div>
                    </div>


                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A6} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid">What is a smart city?</p>
                            <p className="dateArticleSlid">4 Avril, 2018</p>
                        </div>
                    </div>

                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A7} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid" style={{ fontSize: "14px" }}>3 principal ways the IoT is transforming companies</p>
                            <p className="dateArticleSlid">3 Mars, 2018</p>
                        </div>
                    </div>
                    <div>
                        <div className="containerImgSlid">
                            <div className="imagewithtext">
                            <img  src={image_A8} alt="" className="image" />             
                            <div className="bottom-left"><div className="newbadge" style={{background:"#a9ce4e"}}><p className="badgeTextStyle">Entreprise</p></div></div>
                            <div className="overlay">
                                <div className="text">
                                    2018 has been a challenging journey, full of inspiring achievements and moments of genuine hope for all of us. We had enjoyable
                                    moments and hard ones. But in the end, we rised and made it through 2018. One more year of arduous missions and successful projects...
                                    <ReactSVG style={{ marginTop: "5%" }} src={arrow} />
                                </div>
                            </div>
                            </div>
                            <p className="titleArticleSuivSlid">How IoT impacts society?</p>
                            <p className="dateArticleSlid">28 Novembre, 2017</p>
                        </div>
                    </div>
                </Slider>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/responsive/sliderBlog.js